import { useEffect, useState } from "react";
import { Button, Modal } from "../../components/ui";
import { formatMonthLabel, formatMoney } from "./paymentsUtils";
import PaymentMessage from "./PaymentMessage";
import "./TransferModal.css";

export default function TransferModal({
  month,
  submitting,
  message,
  onClose,
  onConfirm,
}) {
  const [receiptFile, setReceiptFile] = useState(null);

  useEffect(() => {
    setReceiptFile(null);
  }, [month]);

  return (
    <Modal
      isOpen={!!month}
      onClose={onClose}
      title="Confirm Transfer"
      size="md"
      footer={
        <div className="modal-footer-actions">
          <Button variant="secondary" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => onConfirm(receiptFile)}
            loading={submitting}
          >
            Confirm Transfer
          </Button>
        </div>
      }
    >
      {month && (
        <div className="transfer-modal-content">
          <p className="transfer-detail">
            Month: <strong>{formatMonthLabel(month)}</strong>
          </p>
          <p className="transfer-detail">
            Amount to transfer:{" "}
            <strong>{formatMoney(month.totalDue - month.totalPaid)}</strong>
          </p>
          <p className="transfer-detail">
            Sessions:{" "}
            <strong>
              {month.sessions.filter((session) => !session.transferred).length}
            </strong>
          </p>
          <div className="receipt-upload-group">
            <label className="filter-label">Upload Transfer Receipt *</label>
            <input
              className="receipt-file-input"
              type="file"
              accept=".pdf,.png,.jpg,.jpeg"
              onChange={(event) =>
                setReceiptFile(event.target.files?.[0] || null)
              }
            />
            {receiptFile && (
              <span className="receipt-file-name">{receiptFile.name}</span>
            )}
            <p className="receipt-hint">A receipt is required to confirm the transfer.</p>
          </div>
          <PaymentMessage message={message} />
        </div>
      )}
    </Modal>
  );
}
